import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navigationBar.css';
import logo from '../../../assets/images/nishad-logo.png';
import RouteConstants from '../../../utils/RouteConstants';
import { openQuoteChat } from '../../../utils/site';
import siteChromeData from '../../../data/content/siteChrome.json';
import AppImage from '../media/AppImage';

const NavigationBar = () => {
  const location = useLocation();
  // Netlify serves pre-rendered pages at /page/, but links and history can use /page.
  const withoutSlash = (path) => path.replace(/\/+$/, '') || '/';
  const pathname = withoutSlash(location.pathname);
  const isHomeRoute = pathname === RouteConstants.HOME || pathname === RouteConstants.ABOUT_PRODUCTS;
  const isActiveLink = (path) => {
    if (path === RouteConstants.HOME) {
      return isHomeRoute;
    }

    return pathname === withoutSlash(path);
  };
  const navbar = { ...siteChromeData.navbar, links: siteChromeData.navbar.links.filter((item) => !item.hidden) };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link
          to={RouteConstants.HOME}
          className="navbar-brand"
          onClick={(e) => {
            if (isHomeRoute) {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          <AppImage src={logo} alt="NISHAD" className="navbar-logo" width="120" height="40" priority />
        </Link>

        <ul className="navbar-menu">
          {navbar.links.map((item) => (
            <li key={item.to} className="navbar-menu-item">
              <Link
                to={item.to}
                className={`navbar-link ${isActiveLink(item.to) ? 'active' : ''}`}
                aria-current={isActiveLink(item.to) ? 'page' : undefined}
              >
                {item.label}
              </Link>
            </li>
          ))}
          {navbar.brandLink ? (
            <li className="navbar-brand-link-item">
              <Link
                to={navbar.brandLink.to}
                className={`navbar-brand-link ${isActiveLink(navbar.brandLink.to) ? 'active' : ''}`}
                aria-current={isActiveLink(navbar.brandLink.to) ? 'page' : undefined}
              >
                <span className="navbar-brand-link-eyebrow">{navbar.brandLink.eyebrow}</span>
                <span className="navbar-brand-link-label">{navbar.brandLink.label}</span>
              </Link>
            </li>
          ) : null}
        </ul>

        <div className="navbar-actions">
          <button type="button" className="btn btn-primary btn-sm" onClick={openQuoteChat}>
            {navbar.quoteLabel}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
